import { Category, Reply } from '../interfaces';

export function transformToLocalStructure(payload): Category[] {
  const categoryMap = {};
  payload.items.forEach((item, _index) => {
    if (!categoryMap[item.category]) {
      categoryMap[item.category] = {
        id: item.id.toString(),
        name: item.category,
        replies: [],
      };
    }

    categoryMap[item.category].replies.push({
      name: item.name,
      category: item.category,
      document: item.document.replace(/"/g, ''),
      isDynamicContent: item.isDynamicContent,
      type: item.type,
    });
  });

  return Object.values(categoryMap);
}

export function formatDocumentProperty(replies: Reply[]): Reply[] {
  return replies.map(reply => ({
    ...reply,
    document: JSON.stringify(reply.document),
  }));
}
